<mat-card class="card-section mat-elevation-z8">
    <mat-card-title><h1>User Profile</h1></mat-card-title>
    <mat-card-subtitle>{{currentUser.displayName}}<br /> {{systemDate}}</mat-card-subtitle>
    <mat-card-content>
        <form #timeForm="ngForm" class="form-container">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Display Name</mat-label>
                        <input placeholder="display name" matInput disabled type="text" name="displayName"
                            [(ngModel)]="currentUser.displayName">
                    </mat-form-field>

                </div>
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Job Title</mat-label>
                        <input placeholder="title" matInput disabled type="text" name="jobTitle"
                            [(ngModel)]="currentUser.jobTitle">
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Department</mat-label>
                        <input placeholder="department" matInput disabled type="text" name="department"
                            [(ngModel)]="currentUser.department">
                    </mat-form-field>

                </div>
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Business Phone(s)</mat-label>
                        <input placeholder="business phone" matInput disabled type="text" name="businessPhones"
                            [(ngModel)]="currentUser.businessPhones">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>User Principal Name</mat-label>
                          <textarea [cdkTextareaAutosize]="true" placeholder="access token" name="accToken" rows=1 matInput disabled>{{currentUser.userPrincipalName}}</textarea>
    
                        <!--input placeholder="principal name" matInput disabled type="text" name="mail"
                            [(ngModel)]="currentUser.userPrincipalName"--> 
                    </mat-form-field>
                 </div>
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Azure ID</mat-label>
                        <input placeholder="azure ID" matInput disabled type="text" name="azureId"
                            [(ngModel)]="currentUser.id">
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="currentUser.manager">
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Manager Name</mat-label>
                        <input placeholder="manager name" matInput disabled type="text" name="azureManagerName"
                            [(ngModel)]="currentUser.manager.displayName">
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Manager Principal Names</mat-label>
                        <input placeholder="user principal" matInput disabled type="text" name="mail"
                            [(ngModel)]="currentUser.manager.userPrincipalName">
                    </mat-form-field>

                </div>

            </div>
        </form>

    </mat-card-content>
    <!--mat-card-footer -->
    <mat-card-footer *ngIf="currentUser.mail?.toLowerCase()?.includes('steven.lamont')">
        <!--button (click)="soModalService.open('modal-2')">Open Modal 2</button-->
        <mat-icon matTooltip="click for instructions to screenshot the dashboard." (click)="soModalService.open('modal-2')" [inline]="true" >info</mat-icon>

        <so-modal id="modal-2">
           <so-snapshot></so-snapshot>
        </so-modal>

        <p>
            
            <button type="button" mat-raised-button [cdkCopyToClipboard]="appToken||''">Copy to clipboard</button>

            <mat-form-field class="full-width">
                <mat-label>Application Token</mat-label>
                <textarea [cdkTextareaAutosize]="true" placeholder="access token" name="accToken" rows=20 matInput disabled>{{appToken}}</textarea>
            </mat-form-field>


        </p>
        <p>
            <button type="button" mat-raised-button [cdkCopyToClipboard]="currentUser.accessToken||''">Copy to clipboard</button>

            <mat-form-field class="full-width">
                <mat-label>Graph Token</mat-label>
                <textarea [cdkTextareaAutosize]="true" placeholder="access token" name="accToken" rows=20 matInput
                    disabled>{{currentUser.accessToken}}</textarea>
            </mat-form-field>


        </p>
    </mat-card-footer>
</mat-card>
<br>
<hr>
<div *ngIf="currentUser.mail?.toLowerCase()?.includes('steven.lamont')">
    <div class="container text-center mt-5">

        <p>Window width: <strong>{{ getScreenWidth }}</strong></p>
        <p>Window height: <strong>{{ getScreenHeight }}</strong></p>
      
      </div>
      
    <p class="text-center" *ngIf="loginDisplay">
        See below the claims in your <strong> ID token </strong>. For more information, visit:
        <span>
            <a href="https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token">
                docs.microsoft.com
            </a>
        </span>
    </p>
    <div id="table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="loginDisplay">
            <!-- Claim Column -->
            <ng-container matColumnDef="claim">
                <th mat-header-cell *matHeaderCellDef> Claim </th>
                <td mat-cell *matCellDef="let element"> {{element.claim
                    }} </td>
            </ng-container>

            <!-- Value Column -->
            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef> Value </th>
                <td mat-cell *matCellDef="let element"> {{element.value}} </td>
            </ng-container>

            <!-- Value Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let element"> {{element.description}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <hr />

    </div>
</div>
